import * as React from "react";
import { forwardRef } from "react";
const SvgTable = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.375 9.375V2.5H4.79167C3.52792 2.5 2.5 3.52792 2.5 4.79167V9.375H9.375ZM10.625 9.375H17.5V4.79167C17.5 3.52792 16.4721 2.5 15.2083 2.5H10.625V9.375ZM9.375 10.625H2.5V15.2083C2.5 16.4721 3.52792 17.5 4.79167 17.5H9.375V10.625ZM10.625 10.625V17.5H15.2083C16.4721 17.5 17.5 16.4721 17.5 15.2083V10.625H10.625Z", fill: "#4EBC44" }));
const ForwardRef = forwardRef(SvgTable);
export default ForwardRef;
